const upsertMeta = (selector, attributes) => {
  let element = document.head.querySelector(selector);
  if (!element) {
    element = document.createElement('meta');
    document.head.appendChild(element);
  }
  Object.entries(attributes).forEach(([key, value]) => element.setAttribute(key, value));
};

const upsertCanonical = (href) => {
  let element = document.head.querySelector('link[rel="canonical"]');
  if (!href) {
    element?.remove();
    return;
  }
  if (!element) {
    element = document.createElement('link');
    element.setAttribute('rel', 'canonical');
    document.head.appendChild(element);
  }
  element.setAttribute('href', href);
};

export const setPageSeo = ({ title, description, canonical, image, robots = 'index, follow, max-image-preview:large, max-snippet:-1' }) => {
  if (typeof document === 'undefined') return;

  document.title = title;
  upsertCanonical(canonical);
  upsertMeta('meta[name="robots"]', { name: 'robots', content: robots });
  upsertMeta('meta[name="title"]', { name: 'title', content: title });
  upsertMeta('meta[name="description"]', { name: 'description', content: description });
  upsertMeta('meta[property="og:url"]', { property: 'og:url', content: canonical || '' });
  upsertMeta('meta[property="og:title"]', { property: 'og:title', content: title });
  upsertMeta('meta[property="og:description"]', { property: 'og:description', content: description });
  upsertMeta('meta[property="og:image"]', { property: 'og:image', content: image });
  upsertMeta('meta[property="twitter:url"]', { property: 'twitter:url', content: canonical || '' });
  upsertMeta('meta[property="twitter:title"]', { property: 'twitter:title', content: title });
  upsertMeta('meta[property="twitter:description"]', { property: 'twitter:description', content: description });
  upsertMeta('meta[property="twitter:image"]', { property: 'twitter:image', content: image });
};